// SOT:AGENT_MODELS — Canonical LLM model registry (OpenAI, Google, Anthropic). All supported models defined here.
export const VAPI_OPENAI_MODELS = [
    'gpt-6-luna',
    'gpt-5.6-sol',
    'gpt-5.6-sol-2026-07-09',
    'gpt-5.6-terra',
    'gpt-5.6-terra-2026-07-09',
    'gpt-5.6-luna',
    'gpt-5.6-luna-2026-07-09',
    'gpt-5.5',
    'chat-latest',
    'gpt-5.4',
    'gpt-5.4-mini',
    'gpt-5.4-nano',
    'gpt-5.2',
    'gpt-5.2-chat-latest',
    'gpt-5.1',
    'gpt-5.1-chat-latest',
    'gpt-5',
    'gpt-5-chat-latest',
    'gpt-5-mini',
    'gpt-5-nano',
    'gpt-4.1-2025-04-14',
    'gpt-4.1-mini-2025-04-14',
    'gpt-4.1-nano-2025-04-14',
    'gpt-4.1',
    'gpt-4.1-mini',
    'gpt-4.1-nano',
    'chatgpt-4o-latest',
    'o3',
    'o3-mini',
    'o4-mini',
    'o1-mini',
    'o1-mini-2024-09-12',
    'gpt-4o-realtime-preview-2024-10-01',
    'gpt-4o-realtime-preview-2024-12-17',
    'gpt-4o-mini-realtime-preview-2024-12-17',
    'gpt-realtime-2025-08-28',
    'gpt-realtime-mini-2025-12-15',
    'gpt-realtime-2',
    'gpt-live-1',
    'gpt-4o-mini-2024-07-18',
    'gpt-4o-mini',
    'gpt-4o',
    'gpt-4o-2024-05-13',
    'gpt-4o-2024-08-06',
    'gpt-4o-2024-11-20',
    'gpt-4-turbo',
    'gpt-4-turbo-2024-04-09',
    'gpt-4-turbo-preview',
    'gpt-4-0125-preview',
    'gpt-4-1106-preview',
    'gpt-4',
    'gpt-4-0613',
    'gpt-3.5-turbo',
    'gpt-3.5-turbo-0125',
    'gpt-3.5-turbo-1106',
    'gpt-3.5-turbo-16k',
    'gpt-3.5-turbo-0613',
    'gpt-4.1-2025-04-14:westus',
    'gpt-4.1-2025-04-14:eastus2',
    'gpt-4.1-2025-04-14:eastus',
    'gpt-4.1-2025-04-14:westus3',
    'gpt-4.1-2025-04-14:northcentralus',
    'gpt-4.1-2025-04-14:southcentralus',
    'gpt-4.1-2025-04-14:westeurope',
    'gpt-4.1-2025-04-14:germanywestcentral',
    'gpt-4.1-2025-04-14:polandcentral',
    'gpt-4.1-2025-04-14:spaincentral',
    'gpt-4.1-mini-2025-04-14:westus',
    'gpt-4.1-mini-2025-04-14:eastus2',
    'gpt-4.1-mini-2025-04-14:eastus',
    'gpt-4.1-mini-2025-04-14:westus3',
    'gpt-4.1-mini-2025-04-14:northcentralus',
    'gpt-4.1-mini-2025-04-14:southcentralus',
    'gpt-4.1-mini-2025-04-14:westeurope',
    'gpt-4.1-mini-2025-04-14:germanywestcentral',
    'gpt-4.1-mini-2025-04-14:polandcentral',
    'gpt-4.1-mini-2025-04-14:spaincentral',
    'gpt-4.1-nano-2025-04-14:westus',
    'gpt-4.1-nano-2025-04-14:eastus2',
    'gpt-4.1-nano-2025-04-14:westus3',
    'gpt-4.1-nano-2025-04-14:northcentralus',
    'gpt-4.1-nano-2025-04-14:southcentralus',
    'gpt-4o-2024-11-20:swedencentral',
    'gpt-4o-2024-11-20:westus',
    'gpt-4o-2024-11-20:eastus2',
    'gpt-4o-2024-11-20:eastus',
    'gpt-4o-2024-11-20:westus3',
    'gpt-4o-2024-11-20:southcentralus',
    'gpt-4o-2024-11-20:westeurope',
    'gpt-4o-2024-11-20:germanywestcentral',
    'gpt-4o-2024-11-20:polandcentral',
    'gpt-4o-2024-11-20:spaincentral',
    'gpt-4o-2024-08-06:westus',
    'gpt-4o-2024-08-06:westus3',
    'gpt-4o-2024-08-06:eastus',
    'gpt-4o-2024-08-06:eastus2',
    'gpt-4o-2024-08-06:northcentralus',
    'gpt-4o-2024-08-06:southcentralus',
    'gpt-4o-mini-2024-07-18:westus',
    'gpt-4o-mini-2024-07-18:westus3',
    'gpt-4o-mini-2024-07-18:eastus',
    'gpt-4o-mini-2024-07-18:eastus2',
    'gpt-4o-mini-2024-07-18:northcentralus',
    'gpt-4o-mini-2024-07-18:southcentralus',
    'gpt-4o-2024-05-13:eastus2',
    'gpt-4o-2024-05-13:eastus',
    'gpt-4o-2024-05-13:northcentralus',
    'gpt-4o-2024-05-13:southcentralus',
    'gpt-4o-2024-05-13:westus3',
    'gpt-4o-2024-05-13:westus',
    'gpt-4-turbo-2024-04-09:eastus2',
    'gpt-4-0125-preview:eastus',
    'gpt-4-0125-preview:northcentralus',
    'gpt-4-0125-preview:southcentralus',
    'gpt-4-1106-preview:australiaeast',
    'gpt-4-1106-preview:canadaeast',
    'gpt-4-1106-preview:france',
    'gpt-4-1106-preview:india',
    'gpt-4-1106-preview:norway',
    'gpt-4-1106-preview:swedencentral',
    'gpt-4-1106-preview:uk',
    'gpt-4-1106-preview:westus',
    'gpt-4-1106-preview:westus3',
    'gpt-4-0613:canadaeast',
    'gpt-3.5-turbo-0125:canadaeast',
    'gpt-3.5-turbo-0125:northcentralus',
    'gpt-3.5-turbo-0125:southcentralus',
    'gpt-3.5-turbo-1106:canadaeast',
    'gpt-3.5-turbo-1106:westus',
    'gpt-4.1:australiaeast',
    'gpt-4o:australiaeast',
    'gpt-5.4-mini:australiaeast',
    'gpt-5.6-sol:westus3',
    'gpt-5.6-terra:westus3',
    'gpt-5.6-luna:westus3'
];
export const VAPI_GOOGLE_MODELS = [
    'gemini-3.5-flash',
    'gemini-3.1-flash-lite',
    'gemini-3-flash-preview',
    'gemini-2.5-pro',
    'gemini-2.5-flash',
    'gemini-2.5-flash-lite',
    'gemini-2.0-flash-thinking-exp',
    'gemini-2.0-pro-exp-02-05',
    'gemini-2.0-flash',
    'gemini-2.0-flash-lite',
    'gemini-2.0-flash-exp',
    'gemini-2.0-flash-realtime-exp',
    'gemini-1.5-flash',
    'gemini-1.5-flash-002',
    'gemini-1.5-pro',
    'gemini-1.5-pro-002',
    'gemini-1.0-pro'
];
export const VAPI_ANTHROPIC_MODELS = [
    'claude-3-opus-20240229',
    'claude-3-sonnet-20240229',
    'claude-3-haiku-20240307',
    'claude-3-5-sonnet-20240620',
    'claude-3-5-sonnet-20241022',
    'claude-3-5-haiku-20241022',
    'claude-3-7-sonnet-20250219',
    'claude-opus-4-20250514',
    'claude-opus-4-5-20251101',
    'claude-opus-4-6',
    'claude-sonnet-4-20250514',
    'claude-sonnet-4-5-20250929',
    'claude-sonnet-4-6',
    'claude-sonnet-5',
    'claude-haiku-5-5',
    'claude-haiku-4-5-20251001'
];
export const VAPI_AGENT_MODELS = [
    ...VAPI_OPENAI_MODELS,
    ...VAPI_GOOGLE_MODELS,
    ...VAPI_ANTHROPIC_MODELS
];
export const getVapiModelProvider = (model) => {
    if (VAPI_OPENAI_MODELS.includes(model))
        return 'openai';
    if (VAPI_GOOGLE_MODELS.includes(model))
        return 'google';
    if (VAPI_ANTHROPIC_MODELS.includes(model))
        return 'anthropic';
    return undefined;
};
export const getPinnedAzureRegion = (model) => model.split(':')[1];
// A pinned model only stays in its Azure region if its fallbacks are pinned there too
export const isFallbackInPrimaryRegion = (primaryModel, fallbackModel) => {
    const region = getPinnedAzureRegion(primaryModel);
    return !region || getPinnedAzureRegion(fallbackModel) === region;
};
export const isUsAzureModel = (model) => getPinnedAzureRegion(model) === 'westus3';
// VAPI's westus3 ids are dated for gpt-4.x and undated for gpt-5.6, so the pin can't be derived from the name
const US_AZURE_MODEL_BY_MODEL = {
    'gpt-4.1': 'gpt-4.1-2025-04-14:westus3',
    'gpt-4.1-2025-04-14': 'gpt-4.1-2025-04-14:westus3',
    'gpt-4.1-mini': 'gpt-4.1-mini-2025-04-14:westus3',
    'gpt-4.1-mini-2025-04-14': 'gpt-4.1-mini-2025-04-14:westus3',
    'gpt-4.1-nano': 'gpt-4.1-nano-2025-04-14:westus3',
    'gpt-4.1-nano-2025-04-14': 'gpt-4.1-nano-2025-04-14:westus3',
    'gpt-4o': 'gpt-4o-2024-08-06:westus3',
    'gpt-4o-2024-05-13': 'gpt-4o-2024-05-13:westus3',
    'gpt-4o-2024-08-06': 'gpt-4o-2024-08-06:westus3',
    'gpt-4o-2024-11-20': 'gpt-4o-2024-11-20:westus3',
    'gpt-4o-mini': 'gpt-4o-mini-2024-07-18:westus3',
    'gpt-4o-mini-2024-07-18': 'gpt-4o-mini-2024-07-18:westus3',
    'gpt-4-1106-preview': 'gpt-4-1106-preview:westus3',
    'gpt-5.6-sol': 'gpt-5.6-sol:westus3',
    'gpt-5.6-sol-2026-07-09': 'gpt-5.6-sol:westus3',
    'gpt-5.6-terra': 'gpt-5.6-terra:westus3',
    'gpt-5.6-terra-2026-07-09': 'gpt-5.6-terra:westus3',
    'gpt-5.6-luna': 'gpt-5.6-luna:westus3',
    'gpt-5.6-luna-2026-07-09': 'gpt-5.6-luna:westus3'
};
export const toUsAzureModel = (model) => US_AZURE_MODEL_BY_MODEL[model.replace(/:.*$/, '')];
// Claude 3.7 through 4.x accept the fixed-budget thinking config; older Claude, GPT, and Gemini
// entries do not, and claude-sonnet-5 rejects budgetTokens (adaptive/disabled only)
const THINKING_CAPABLE_MODEL_PREFIXES = [
    'claude-3-7-sonnet',
    'claude-opus-4',
    'claude-sonnet-4',
    'claude-haiku-4'
];
export const modelSupportsThinking = (model) => THINKING_CAPABLE_MODEL_PREFIXES.some((prefix) => model.startsWith(prefix));
// Anthropic requires budget_tokens >= 1024 and < maxTokens
export const THINKING_BUDGET_TOKENS = 1024;
//# sourceMappingURL=agent-models.js.map